<template lang="pug">
  v-dialog(v-model="value" width="575" persistent lazy)
    v-card
      title-bar.py-4(dark) 
        | EXPORT HISTORY
      div(v-if="hasFiles")
        div.ma-4(v-if="hasFiles")
          | You have {{totalFiles}} files available to download
        v-progress-linear(:indeterminate="true" v-show="isExportHistoryLoading || isLoading")
        div.files-scroll
          v-data-table.files-table(
                data-cy="files-table"
                :headers="headers"
                :items="exportedFiles"
                item-key="id"
                hide-actions
                hide-headers
                loading=true
                color="primary"
                :class="{ 'in-progress': isLoading }"
                disable-initial-sort
              )
              template(slot="items" slot-scope="props")
                tr(:id="props.item.id")
                  td.type
                    v-icon {{ iconFromFileName(props.item.file_name) }}
                  td.description
                    | {{ props.item.file_name }}
                  td.action.primary--text
                    v-btn.px-2(
                      color="primary"
                      flat
                      @click="downloadFile(props.item.id)"
                    )
                      v-icon.primary--text download 
                      | Download
          scroll-observer(@intersecting="getExportedFiles")
      v-layout.justify-center.ma-5(v-else-if="isExportHistoryLoading")
        v-progress-circular.progress-circular(
            v-if="isExportHistoryLoading"
            indeterminate
            color="primary"
          )
      div(v-else)
        div.ma-4
          | Your export history is empty, your export contacts files will appear here once generated.
      v-snackbar(:value="fileErrorMessage" color="error")
        div {{ fileErrorMessage }}
      v-card-actions.pa-3
        v-layout(row justify-end)
          v-btn.primary--text(flat @click="$emit('close')") Close
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import ScrollObserver from '@/Core/components/ScrollObserver';

const {
  mapActions: mapContactsExportActions,
  mapState: mapContactsExportState,
} = createNamespacedHelpers('contactsExport');

const {
  mapActions: mapExportedFilesActions,
  mapState: mapExportedFilesState,
} = createNamespacedHelpers('exportedFiles');

export default {
  name: 'ExportHistoryModal',
  components: { 
    TitleBar,
    ScrollObserver,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      currentPage: 0,
      exportedFiles: [],
      shouldGetMoreFiles: true,
      headers: [
          { text: 'Id', value: 'id' },
          { text: 'File', value: 'file_name' },
      ],
    };
  },
  computed: {
    ...mapContactsExportState([
      'exportHistoryFiles',
      'isExportHistoryLoading',
      'totalFiles',
    ]),
    ...mapExportedFilesState([
      'fileData',
      'fileErrorMessage',
      'isLoading',
    ]),
    hasFiles() {
      return !!this.exportedFiles.length;
    }
  },
  watch: {
    value(value) {
      if (!value) return;
      this.resetData();
      this.getExportedFiles();
    },
    fileData(value) {
      this.handleFileData(value);
    },
  },
  methods: {
    ...mapContactsExportActions([
      'getExportHistory',
    ]),
    ...mapExportedFilesActions([
      'getFile',
    ]),
    iconFromFileName(fileName) {
      const fileType = fileName.split(".").reverse()[0];
      switch(fileType){
        case 'xlsx':
          return '$vuetify.icons.file-excel';
        default:
          return '$vuetify.icons.file-document';
      }
    },
    async downloadFile(idFile) {
      this.getFile({
        fileId: idFile,
        shouldRedirect: false,
      });
    },
    handleFileData(fileData) {
      if (!fileData || !fileData.data) return;

      const fileURL = window.URL.createObjectURL(fileData.data);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', fileData.fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    resetData() {
      this.shouldGetMoreFiles = true;
      this.currentPage = 0;
      this.exportedFiles = [];
    },
    async getExportedFiles() {
      if (this.isExportHistoryLoading || !this.shouldGetMoreFiles) return;
      await this.getExportHistory(this.currentPage);
      this.shouldGetMoreFiles = !!this.exportHistoryFiles.length;
      this.currentPage = this.currentPage + 1;
      this.exportedFiles = [...this.exportedFiles, ...this.exportHistoryFiles];
    },
  },
};
</script>

<style lang="scss" scoped>
.files-table {
  .v-table {
    tbody {
      td {
        padding: 6px 24px;
      }

      tr:hover {
        box-shadow: none;
        -webkit-box-shadow: none;
      }
    }

    td.type {
      width: 30px;
      padding-right: 8px;
      .v-icon {
        height: 30px;
        width: 30px;
      }
    }

    td.description {
      padding-left: 8px;
      width: 415px;
    }

    td.action {
      text-align: right;
      cursor: pointer;

      .v-btn {
        font-weight: normal;
        font-size: 12px;
        text-transform: none;
        margin-right: 0px;
        padding-right: 0px;

        .v-icon {
          height: 15px;
          width: 15px;
          margin-right: 8px;
        }
      }
    }
  }
}

.files-scroll {
  width: 100%;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>